// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import stickyHeader from "./stickyHeader";
import infiniteScroll from "./infiniteScroll";
import slider from "./slider";
import counters from "./counters";
import flipCards from "./flipCards";


menuOpen();
stickyHeader();
infiniteScroll();
slider();
counters();
flipCards();
